import React, { useState } from "react";
import styled from "@emotion/styled";
import { useReportMonk } from "../../context/reportMonk";
import BG from "../../assets/images/dayHeaderBG.svg";

const DayTotalScore = (props) => {
  const { getCurrentDatetotal4D } = useReportMonk();
  return (
    <>
      <BGDIV>
        <TotalScoreCard>
          <TotalTitle>ผลคะแนนรายวัน</TotalTitle>
          <br />
          <TotalScore>
            <center>{getCurrentDatetotal4D("-")}</center>
          </TotalScore>
          <TotalLabelContainer>
            <TotalLabel>คะแนนรวม 4 เป้าหมาย</TotalLabel>
          </TotalLabelContainer>
        </TotalScoreCard>
      </BGDIV>
    </>
  );
};

const TotalTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  /* identical to box height, or 130% */

  text-align: center;

  /* Primary/Green 500 */

  color: #058459;
`;

const TotalLabelContainer = styled.div`
  margin-left: 150px;
  width: 67px;

  margin-top: 22px;
`;

const TotalScore = styled.div`
  float: right;
  width: 100px;
  height: 46px;
  /* Secondary/500 */

  background: #fb633d;
  border-radius: 8px;
  margin-top: 22px;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 26px;
  /* identical to box height, or 108% */

  text-align: center;

  /* Shades/White */

  color: #ffffff;
  padding-top: 11px;
`;

const TotalLabel = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* or 133% */

  /* Neutral / 600 */

  color: #4b5768;
`;

const BGDIV = styled.div`
  background: #ffffff;

  height: 120px;
  width: 340px;
  margin-top: 24px;
  box-shadow: 0px -7px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 0px 0px;

  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 12px;
`;

const TotalScoreCard = styled.div`
  width: 100%;
  height: 100%;
  background: url(${BG});
  background-repeat: no-repeat;
`;

export default DayTotalScore;
